import { render, staticRenderFns } from "./RentalClientComponent.vue?vue&type=template&id=90ecc4dc&"
import script from "./RentalClientComponent.vue?vue&type=script&lang=js&"
export * from "./RentalClientComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports